'use client';

import { useStoreSetting } from '@/app/(store)/s/[domain]/store-context';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { SORTING_QUERY } from '@/constant/data';
import { SortDesc } from 'lucide-react';
import React from 'react';

interface SortingProps {
  updateSortBy: (sortBy: string) => void;
  currentSorting: string;
}

export default function Sorting({ updateSortBy, currentSorting }: SortingProps) {
  const { storeSetting } = useStoreSetting();

  const isReviewActive = storeSetting?.product_settings?.review_product ?? false;

  const availableSortingOptions = SORTING_QUERY.filter((item) => {
    if (item.sortBy === 'rating_average') {
      return isReviewActive;
    }
    return true;
  });

  return (
    <div className='flex w-full flex-col gap-3 md:flex-row md:items-center'>
      <SortDesc className='text-sm' />
      <span className='text-sm'>Sort by:</span>
      <Select defaultValue={currentSorting} value={currentSorting} onValueChange={updateSortBy}>
        <SelectTrigger className='w-full md:w-48'>
          <SelectValue placeholder='Alphabetically, A-Z' />
        </SelectTrigger>
        <SelectContent className='z-[110] w-full'>
          {availableSortingOptions.map((item, index) => (
            <SelectItem key={index} value={item.value}>
              {item.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
